import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Button, Input, Select, Icon, Popover, Checkbox, message, Radio } from 'antd';
import {
  ModalBody,
  ModalContainer,
  InputLabel,
  Container,
  AddNewCategory,
  InputContainer,
  PopupContainer,
  PopupActionContainer,
  PopupLabel,
  SaveButton,
  CancelButton,
  WarningLabel,
  CategoryInputLabel,
  InputFlexColumn,
} from './styles';
import Loader from '../Loader';
import NoTeam from '../NoTeam';
import { AppStoreContext } from '../../context/appStoreContext';
import { getAllCategories, createCategory } from '../../utils/services/categoriesAPI';
import { DEFAULT_FONT_FOR_LOCALISED_LANGUAGES ,handleCommunNameCheck,SUPPORT_EMAIL_ID } from '../../utils/helper';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import { CREATE_NEW_TEMPLATE_MODAL, MAIL_TEMPLATE_MODAL } from './translationValues';
import { useTranslation } from 'react-i18next';
import { createEmailTemplate, verifiedFromAddressList, getMasterEmails, patchComplexEmail, createEmailTemplateWithBlock } from '../../utils/services/complexEmailAPI';
import { importVariables } from '../../utils/importHelper';
import { importBusinessLogics, modifyMasterTemplateFlows } from '../../utils/masterTemplateHelper';
import {
  useDocumentContext,
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
} from '../../context/complexDocumentContext';
import UpgradePlanModal from '../Modals/UpgradePlanModal';
import { TEMPLATE_NAME_CHAR_LIMIT } from '../../utils/constants/appConstants';
import { dummyCallback } from '../../utils/complexDocumentConstants';
import { BusinessLogic } from '../../context/businessLogicContext';
import { useDefaultStyleContext } from '../../context/complexDefaultStyleContext';
import { generatePDFPayload } from '../../containers/ComplexDocumentDesign/complexDocumentHelper';
import { docToEmail } from '../../utils/documentToEmail';
import { deepCopy } from '../../utils/javascript';
import _ from 'underscore';
import { AvailableLanguagesDropdown, useSelectedTemplateLanguage } from './AvailableLanguagesDropdown';
import { isLanguageTranslationDisabled } from '../../utils/detectLanguageHelper';
import { useSessionContext } from '../../context/sessionContext';

const { Option } = Select;

const NAMESPACES = ['CREATE_NEW_TEMPLATE_MODAL', "MAIL_TEMPLATE_MODAL"];
const MAIL_TEMPLATE = 'MAIL_TEMPLATE_MODAL';

const CreateComplexEmailTemplate = props => {
  const { onSucess, template, masterTemplate = {}, selectDesign ,
    setDefaultTemplates, isDocToEmail=false, selectFlows= dummyCallback, showFlows=false, categoryId=null,
    resourceGroupId=null, communicationId = null } = props;
  const [templateName, setTemplateName] = useState(template ? template.name : '');
  const [validTempName, setValidTempName] = useState(template?.name ? true : false);
  const [smtpConfig, setSmtpServer] = useState(undefined);
  const [savingLoader, setSavingLoader] = useState(false);
  const [isServersLoading, setLoading] = useState(true);
  const [allCategories, setAllCategories] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(categoryId);
  const [newCategoryName, setNewCategoryName] = useState(null);
  const [validCategName, setValidCategName] = useState(false);
  const [savePopupVisible, setSavePopupVisible] = useState(false);
  const [savingCategory, setSavingCategory] = useState(false);
  const { userDetails, checkUserAccess, licenseDetails } = useContext(AppStoreContext);
  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails] = useSessionContext(organisationSelector);
  const [warningText, setWarningText] = useState('');
  const [allTeams, setAllTeams] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(resourceGroupId);
  const [pageLoading, setPageLoading] = useState(true);
  const [noTeam, setnoTeam] = useState(false);
  const [fromAddressList, setFromAddressList] = useState([]);
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);
  const [autoGenerateMail, setAutoGenerateMail] = useState(false);
  const [emailServiceType, setEmailServiceType] = useState(1);
  const { languages, templateLanguage, setTemplateLanguage } = useSelectedTemplateLanguage();

  const { t, i18n } = useTranslation(NAMESPACES);
  const userType = userDetails.userType;
  const currentLanguage = i18n.language;  
  const templateLimit = userDetails?.planMapping?.templateLimit;

  const contextSelector = useCallback(store => store, []);
  const [documentContext, store] = useDocumentContext(contextSelector);

  const { businessLogics } = useContext(BusinessLogic);

  const artboardSelector = useCallback(
    store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES],
    [],
  );
  const [allVariables] = useDocumentContext(artboardSelector);

  const getDefaultStyleSelector = useCallback(store => store, []);
  const [documentStyle] = useDefaultStyleContext(getDefaultStyleSelector);

  const getSelectedFlowsSelector = useCallback(
    store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.SELECTED_FLOWS],
    [],
  );
  const [selectedFlowUUIDS] = useDocumentContext(getSelectedFlowsSelector);

  useEffect(() => {
    (async () => {
      const response = await getAllCategories(false, 'template');
      if (response && response.data) {
        let loggedUserCategory = response.data.filter(
          categoryObj => userType === categoryObj.categoryusertype,
        );
        setAllCategories(loggedUserCategory);
      }
      const teamData = await getGroupPermission(true);
      if (teamData?.data) {
        if (teamData.data.length === 1) {
          setSelectedGroup(teamData.data[0].rgId);
        }
        if (teamData.length === 0) {
          setnoTeam(true);
        }
        setAllTeams(teamData.data);
      } else {
        setnoTeam(true);
      }
      setPageLoading(false);
    })();
    // eslint-disable-next-line
  }, []);

  const getEmailId = (smtpConfig) => {
    const result = fromAddressList.find(list => list.emailFromAddress === smtpConfig);
    return  result.id;
  }

  const createNewEmailTemplate = async () => {
    setSavingLoader(true);
    const payload = {
      "categoryId": selectedCategoryId,
      "resourceGroupId": selectedGroup,
      "documentName": templateName,
      "fromAddressId": licenseDetails?.EmailConfiguration && emailServiceType === 1 ? 0 : getEmailId(smtpConfig),
      "communicationId": communicationId,
      "subject": null,
      "variableContract": [
      ],
      "flows": [
        {
          "orderNumber": 1,
          "flowName": "",
          "style": {
            "fontFamily": DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
            "fontSize": 16,
            "padding": {
              "left": 0,
              "right": 0,
              "top": 0,
              "bottom": 0
            },
            "paperSize": 'custom',
            "width": 590,
            "backgroundColor": "#f5f8fa",
            "color": "#ffffff"
          },
          "blocks": []
        }
      ]
    }
    let response;
    if(isDocToEmail && selectedFlowUUIDS.length > 0){
      const payloadData = generatePDFPayload(allVariables, documentContext, businessLogics, documentStyle, 'document');
      const documentData = deepCopy(payloadData);
      const selectedFlowIds = selectedFlowUUIDS.map(uuid => store.get().backendIds[uuid])
      if(documentData.documentDTO){
        documentData.documentDTO.flows = documentData.documentDTO.flows.filter(flow => selectedFlowIds.includes(flow.flowId));
      }
      payload.flows[0].style.fontFamily = documentStyle.fontFamily;
      payload.flows[0].style.fontSize = documentStyle.fontSize;
      payload.flows[0].style.color = documentData.documentDTO.flows[0].style?.backgroundColor || "#ffffff";
      payload.language = documentContext.language;
      const emailBlocks = docToEmail(documentData.documentDTO, allVariables);
      payload.flows[0].blocks = emailBlocks;

      response = await createEmailTemplateWithBlock(payload);
    }else{
      if (isLanguageTranslationDisabled(organisationDetails) && templateLanguage) {
        payload.language = templateLanguage;
      }
      response = await createEmailTemplate(payload);
    }

    if (response?.statusCode === 702 && response?.errors?.some(error => error?.code === 2422)) {
      setSavingLoader(false);
      setIsLimitExceeded(true);
      return;
    }

    if (response?.data !== null && masterTemplate.id) {
      const payload = { draftEmailId: masterTemplate.id }
      const masterTemplateResponse = await getMasterEmails(payload);
      const globalVariables = documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES];
      const variables = masterTemplateResponse.data[0].variables;
      const businessLogics = masterTemplateResponse.data[0].documentDTO.businessLogics;
      const variableIdMap = await importVariables(variables, globalVariables, store);
      const uploadedUrlsMap = new Map();
      const blBlocks = [];

      const flows = masterTemplateResponse.data[0].documentDTO.flows;
      store.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EMAIL_TEMPLATE]: true });
      await modifyMasterTemplateFlows(flows, blBlocks, variableIdMap, uploadedUrlsMap);

      payload.documentId = response?.data.templateId;

      const updateDocumentFlow = [...flows, {
        flowId: response?.data.flowId,
        isDeleted: true,
        isStandalone: false
      }];

      const updateDocument = {
        documentName: templateName,
        documentId: response?.data.templateId,
        flows: updateDocumentFlow,
        style: masterTemplate.style
      }

      const handleBusinessLogic = (syncData) => {
        return importBusinessLogics(businessLogics, variableIdMap, blBlocks, syncData, undefined, true);
      }
      await patchComplexEmail(updateDocument, undefined, handleBusinessLogic);
    };

    if (response?.statusCode === 701 || response?.statusCode === 703) {
      onSucess(isDocToEmail ? { id: response.data.documentId || response.data.templateId } : response.data);
    } else {
      if (response?.errors?.length > 0 && response.errors[0]) {
        message.error(
          t(
            CREATE_NEW_TEMPLATE_MODAL.UNABLE_To_CREATE_TEMPLATE.key,
            CREATE_NEW_TEMPLATE_MODAL.UNABLE_To_CREATE_TEMPLATE.value,
            { type: 'Email' },
          ),
        );
      }
    }
    setSavingLoader(false);
  }

  const setCategoryName = categoryName => {
    setNewCategoryName(categoryName.trimStart());
    if (categoryName.split(" ").join("").length) {
      setValidCategName(true);
    }
    else {
      setValidCategName(false)
    }
  };

  const handlePopupVisibleChange = visible => {
    setSavePopupVisible(visible);
  };

  const saveNewCategory = () => {
    setSavingCategory(true);
    let payload = {
      name: newCategoryName,
      type: 'template',
    };
    createNewCategory(payload);
  };

  const createNewCategory = async payload => {
    let categoryResponse = await createCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: null,
        id: categoryResponse.id,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: 'template',
        updatedBy: null,
        updatedOn: null,
      };
      setAllCategories(allCategories => [...allCategories, savedCategory]);
      setSavePopupVisible(false);
      setSelectedCategoryId(categoryResponse.id);
      setNewCategoryName(null);
      setSavingCategory(false);
    } else {
      setSavingCategory(false);
    }
  };

  const debouncedNameCheck = useCallback(
    _.debounce(async (name) => {
      const nameCheck = await handleCommunNameCheck(name);
      if (nameCheck.length > 0) {
        setValidTempName(false)
        name !== "" && setWarningText(t(CREATE_NEW_TEMPLATE_MODAL.COMMUNICATION_NAME_VALIDATION.key, CREATE_NEW_TEMPLATE_MODAL.COMMUNICATION_NAME_VALIDATION.value));
      } else {
        setValidTempName(true)
        setWarningText('');
      }
    }, 500),
    []
  );

  const changeTempName = name => {
    setTemplateName(name.trimStart())
    if (name.split(" ").join("").length) {
      if(name.trimStart().length > TEMPLATE_NAME_CHAR_LIMIT) {
        setWarningText(t(CREATE_NEW_TEMPLATE_MODAL.CHAR_LIMIT_EXCEEDED_ERROR.key, CREATE_NEW_TEMPLATE_MODAL.CHAR_LIMIT_EXCEEDED_ERROR.value, { charLimitLength: TEMPLATE_NAME_CHAR_LIMIT }));
        setValidTempName(false);
        return;
      }
      setWarningText('');
      setValidTempName(true);
    }
    else {
      setWarningText(t(CREATE_NEW_TEMPLATE_MODAL.ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE.value));
      setValidTempName(false)
    }
    debouncedNameCheck(name);
  };

  const changeAutoGenerateMail = (e) =>{
    const isAutoGenerateMail = e.target.checked
    setAutoGenerateMail(isAutoGenerateMail);
    selectFlows(isAutoGenerateMail);
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await verifiedFromAddressList('verified');
      response?.data && setFromAddressList(response?.data);
      setSmtpServer(response?.data && response?.data[0]?.emailFromAddress);
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <ModalBody>

        <ModalContainer>
          {pageLoading ? (
            <>
              <Loader />
            </>
          ) : noTeam ? (
            <NoTeam />

          ) : fromAddressList.length === 0 ? (
            <>
              <div className='info-message'>
                Please wait while we set things up for you.
              </div>
              <Loader />
            </>
          ) : (
            <>
              <InputContainer>
                <InputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_LABEL.value)}</InputLabel>
                <Input
                  placeholder={t(CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_PLACEHOLDER.value)}
                  autoComplete="off"
                  name="templateName"
                  onChange={e => {
                    changeTempName(e.target.value);
                  }}
                  size="large"
                  value={templateName}
                  disabled={communicationId !== undefined && template?.name !== undefined}
                />
                {warningText && <WarningLabel>{warningText}</WarningLabel>}
              </InputContainer>
              <InputContainer>
                <InputFlexColumn>
                  <AddNewCategory>
                    <CategoryInputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.SELECT_CATEGORY_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_CATEGORY_LABEL.value)}</CategoryInputLabel>
                    <Popover
                      content={
                        <PopupContainer>
                          <PopupLabel>{t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.value)}</PopupLabel>
                          <Input
                            placeholder={t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.value)}
                            autoComplete="off"
                            name="categoryName"
                            value={newCategoryName}
                            onChange={e => setCategoryName(e.target.value)}
                          />
                          <PopupActionContainer>
                            <CancelButton
                              size="default"
                              onClick={() => handlePopupVisibleChange(false)}
                            >
                              {t(CREATE_NEW_TEMPLATE_MODAL.CANCEL_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.CANCEL_BUTTON.value)}
                            </CancelButton>
                            <SaveButton
                              type="primary"
                              size="default"
                              onClick={() => saveNewCategory()}
                              disabled={!newCategoryName || !validCategName}
                              loading={savingCategory}
                            >
                              {savingCategory ? t(CREATE_NEW_TEMPLATE_MODAL.SAVING_CATEGORY_LOADING_TEXT.key, CREATE_NEW_TEMPLATE_MODAL.SAVING_CATEGORY_LOADING_TEXT.value) : t(CREATE_NEW_TEMPLATE_MODAL.SAVE_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.SAVE_BUTTON.value)}
                            </SaveButton>
                          </PopupActionContainer>
                        </PopupContainer>
                      }
                      placement="leftBottom"
                      trigger="click"
                      visible={savePopupVisible}
                      onVisibleChange={handlePopupVisibleChange}
                    >
                      <Icon type="plus" /> {t(CREATE_NEW_TEMPLATE_MODAL.ADD_NEW_ACTION.key, CREATE_NEW_TEMPLATE_MODAL.ADD_NEW_ACTION.value)}
                    </Popover>
                  </AddNewCategory>
                  <Select
                    loading={!allCategories}
                    showSearch
                    placeholder={t(CREATE_NEW_TEMPLATE_MODAL.SELECT_CATEGORY_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_CATEGORY_PLACEHOLDER.value)}
                    optionFilterProp="children"
                    value={selectedCategoryId ? selectedCategoryId : undefined}
                    onChange={value => setSelectedCategoryId(value)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {allCategories &&
                      allCategories.map(data => {
                        return (
                          <Option key={String(data.id)} value={data.id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputFlexColumn>
              </InputContainer>
              {allTeams.length > 1 && (
                <InputContainer>
                  <InputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_LABEL.value)}</InputLabel>
                  <Select
                    loading={!allTeams}
                    showSearch
                    placeholder={t(CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_PLACEHOLDER.value)}
                    optionFilterProp="children"
                    value={selectedGroup || undefined}
                    onChange={value => setSelectedGroup(value)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {allTeams &&
                      allTeams.map(data => {
                        return (
                          <Option key={String(data.id)} value={data.rgId}>
                            {data.groupName}
                          </Option>
                        );
                      })}
                  </Select>
                </InputContainer>
              )}
              <InputContainer>
                <InputLabel>{t(`${MAIL_TEMPLATE}:${MAIL_TEMPLATE_MODAL.FROM_MAIL_ADDRESS_LABEL.key}`, MAIL_TEMPLATE_MODAL.FROM_MAIL_ADDRESS_LABEL.value)}</InputLabel>
                {licenseDetails?.EmailConfiguration && <>
                  <Radio.Group onChange={(e) => setEmailServiceType(e.target.value)} value={emailServiceType}>
                    <Radio value={1}>External</Radio>
                    <Radio value={2}>SMTP</Radio>
                  </Radio.Group>
                </>}
                {(!licenseDetails?.EmailConfiguration || emailServiceType === 2) && <Select
                  loading={isServersLoading}
                  showSearch
                  placeholder={t(`${MAIL_TEMPLATE}:${MAIL_TEMPLATE_MODAL.SELECT_MAIL_ADDRESS_PLACEHOLDER.key}`, MAIL_TEMPLATE_MODAL.SELECT_MAIL_ADDRESS_PLACEHOLDER.value)}
                  optionFilterProp="children"
                  value={smtpConfig}
                  onChange={value => {
                    setSmtpServer((value));
                  }}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {fromAddressList && fromAddressList?.length !== 0 &&
                    fromAddressList.map(data => {
                      return (
                        <Select.Option key={String(data.emailFromAddress)}>{data.emailFromAddress}</Select.Option>
                      );
                    })}
                </Select>}
              </InputContainer>
              <AvailableLanguagesDropdown
                languages={languages}
                templateLanguage={templateLanguage}
                setTemplateLanguage={setTemplateLanguage}
              />
              {selectDesign && <div className='master-template'>
                <div onClick={setDefaultTemplates} className='btn'>
                  <div className='btn-text'>{Object.keys(masterTemplate).length > 0 ? masterTemplate.name : t(CREATE_NEW_TEMPLATE_MODAL.CLICK_TO_SELECT_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.CLICK_TO_SELECT_BUTTON.value)}</div>
                  {Object.keys(masterTemplate).length > 0 &&
                  <div className="preview-button1">
                    <div class="wrapper">
                      <div class="circle">
                        <div class="checkMark"></div>
                      </div>
                    </div>
                  </div>
                }
                </div>

                <div className='desc'> {t(CREATE_NEW_TEMPLATE_MODAL.MASTER_TEMPLATE_DESC.key, CREATE_NEW_TEMPLATE_MODAL.MASTER_TEMPLATE_DESC.value)}</div>
              </div>}
              {isDocToEmail && (
                <div className="flows-to-email">
                  <Checkbox onChange={changeAutoGenerateMail}>
                    {t(
                      CREATE_NEW_TEMPLATE_MODAL.AUTO_GENERATE_EMAIL.key,
                      CREATE_NEW_TEMPLATE_MODAL.AUTO_GENERATE_EMAIL.value,
                    )}
                  </Checkbox>
                  <div className="desc">
                    {showFlows
                      ? t(
                          CREATE_NEW_TEMPLATE_MODAL.SELECT_FLOWS_HELP_TEXT.key,
                          CREATE_NEW_TEMPLATE_MODAL.SELECT_FLOWS_HELP_TEXT.value,
                        )
                      : t(
                          CREATE_NEW_TEMPLATE_MODAL.ENABLE_AUTO_GENERATE_HELP_TEXT.key,
                          CREATE_NEW_TEMPLATE_MODAL.ENABLE_AUTO_GENERATE_HELP_TEXT.value,
                        )}
                  </div>
                </div>
              )}
              <InputContainer>
                <div className="form_btn">
                  <Button
                    key="submit"
                    type="primary"
                    disabled={!templateName || !validTempName || !selectedCategoryId || (checkUserAccess('client') && !selectedGroup) || ( autoGenerateMail && selectedFlowUUIDS.length < 1 )}
                    loading={savingLoader}
                    onClick={() => createNewEmailTemplate()}
                  >
                    {savingLoader ? t(CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.value) : t(CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.value)}
                  </Button>
                </div>
              </InputContainer>
            </>
          )}
        </ModalContainer>
      </ModalBody>
      <UpgradePlanModal 
        visible={isLimitExceeded}
        modalText={
          userDetails.planMapping.planName === 'Premium' ?
            t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
          : userDetails.planMapping.planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { templateLimit }) 
          : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { templateLimit })
        }
        onCancel={() => setIsLimitExceeded(false)}
      />
    </Container>
  );
};

export default CreateComplexEmailTemplate;
